// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Fu8C","footer":"ReportModalFilter_footer__2J6eE"};